import React from 'react';
import KickLoginButton from '../KickLoginButton';
import { ReactComponent as ReplyIcon } from '../images/kickbadges/kick-reply-icon.svg';
import { renderTruncatedContent } from './KickContent';

const REPLY_BAR_EMOTE = { className: 'reply-emote', style: { height: '16px', width: 'auto', verticalAlign: 'middle', margin: '0 2px' } };

// The bars above the Kick chat input. Purely presentational; KickChatPost owns the state.

// "Replying to @user: ..." with a cancel button
export const KickReplyBar = ({ replyingTo, onCancel }) => (
  <div className="reply-indicator">
    <div className="reply-content">
      <span className="reply-icon">
        <ReplyIcon style={{ width: 12, height: 12 }} title="Reply" className="reply-icon" />
      </span>
      <span className="reply-to-user">@{replyingTo.sender?.username || 'Unknown'}</span>
      <span className="reply-to-text">
        {renderTruncatedContent(replyingTo.content, 100, REPLY_BAR_EMOTE)}
      </span>
    </div>
    <button
      className="reply-cancel"
      onClick={onCancel}
      title="Cancel reply"
      aria-label="Cancel reply"
    >
      ✕
    </button>
  </div>
);

// For moderators whose login doesn't include the opt-in moderation scopes
export const KickModerationPrompt = ({ enableUrl, onDismiss }) => (
  <div className="reply-indicator moderation-prompt">
    {/* Two columns: message with the Enable text button under it, then the dismiss button */}
    <div className="moderation-prompt-content">
      {/* Own class, not reply-to-text: that one is cut to a single line for previews */}
      <span className="moderation-prompt-text">You moderate this channel. Enable moderation tools to delete messages, time out and ban.</span>
      <a href={enableUrl} className="button-label">Enable Moderation Tools</a>
    </div>
    <button
      className="reply-cancel"
      onClick={onDismiss}
      title="Dismiss"
      aria-label="Dismiss moderation tools prompt"
    >
      ✕
    </button>
  </div>
);

// Send errors; showLogin adds the Kick login button (session expired)
export const KickErrorBar = ({ message, showLogin, onDismiss }) => (
  <div className="error-indicator">
    <div className="error-content">
      <span className="error-icon">⚠️</span>
      <span className="error-text">{message}</span>
    </div>
    <div className="error-actions">
      {showLogin && <KickLoginButton />}
      <button
        className="error-dismiss"
        onClick={onDismiss}
        title="Dismiss error"
        aria-label="Dismiss error"
      >
        ✕
      </button>
    </div>
  </div>
);
